<template>
  <div
    :class="{
      grid: true,
      'grid--narrow': isSmallCards,
    }"
  >
    <h2 v-if="title" class="grid__title">{{ title }}</h2>
    <ul class="grid__list">
      <li
        v-for="(element, index) in elements"
        :key="element._key"
        :index="index"
        :item="element"
        class="grid__item"
      >
        <slot :element="element" :index="index" name="element"></slot>
      </li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
  elements: {
    type: Array,
    required: true,
  },
  isSmallCards: {
    type: Boolean,
  },
});
</script>

<style lang="postcss" scoped>
.grid {
  width: 100%;
  max-width: 920px;
  margin: 0 auto;

  &__title {
    font-size: 40px;
    line-height: 46px;
    margin: 80px 0 32px 0;

    @media (--small-vp) {
      font-size: 28px;
      line-height: 34px;
      margin: 80px 0 24px 0;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  &__item {
    width: calc(50% - 10px);

    @media (--small-vp) {
      width: 100%;
    }
  }

  &--narrow {
    & .grid__list {
      gap: 26px;
    }

    & .grid__item {
      width: calc(25% - 26px);

      @media (--tablet-vp) {
        width: calc(33% - 26px);
      }

      @media (--small-vp) {
        width: calc(50% - 16px);
      }

      @media (--x-small-vp) {
        width: calc(50% - 16px);
      }

      @media (max-width: 410px) {
        width: 100%;
      }
    }
  }
}
</style>
